import React from 'react';
import { submitForm } from '../services/form';

// order:
// title
// slug
export class ContactForm extends React.Component {
  state = {};

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    submitForm({
      ...this.state,
      title: this.props.title,
      slug: this.props.slug,
      type: this.props.order ? 'order' : 'feedback',
      purpose: this.props.purpose,
    })
      .then(() => this.setState({ success: true }))
      .catch((e) => {
        if (process.env.NODE_ENV === 'development') {
          console.error('Ошибка отправки формы', e);
        }

        this.setState({ error: true });
      });
  };

  render() {
    const config = this.props.order ? buildOrderConfig(this.props.title) : feedbackConfig;

    return (
      <div>
        <div style={{ position: 'relative' }}>
          <form onSubmit={this.handleSubmit} style={{ position: 'relative', zIndex: 0 }}>
            {config.fields.map((field) => this.renderControl(field))}

            <div className="field">
              <button className="button is-primary is-fullwidth" type="submit">
                {config.submit.caption}
              </button>
            </div>
          </form>{' '}
          {this.state.success && (
            <div
              className="has-text-centered"
              style={{
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                bottom: '0',
                background: 'rgba(255, 255, 255, .8)',
                zIndex: 1,
              }}
            />
          )}
        </div>
        {this.state.success && (
          <div className="has-text-centered" style={{ paddingTop: '16px', fontWeight: 'bold' }}>
            {config.success.text}
          </div>
        )}
      </div>
    );
  }

  renderControl({ caption, type, name, hidden, required, choices, condition }) {
    if (condition) {
      for (const key in condition) {
        if (this.state[key] !== condition[key]) {
          return;
        }
      }
    }

    if (hidden) {
      return;
    }

    if (
      this.props.title &&
      ~this.props.title.indexOf('лаванд') &&
      (name === 'color' || name === 'decor')
    ) {
      return;
    }

    switch (type) {
      case 'text':
        return (
          <div className="field" hidden={hidden} key={name}>
            <label className="label" htmlFor={name}>
              {caption}
            </label>
            <div className="control">
              <input
                className="input"
                type="text"
                name={name}
                onChange={this.handleChange}
                id={name}
                required={required}
              />
            </div>
          </div>
        );
      case 'textarea':
        return (
          <div className="field" hidden={hidden} key={name}>
            <label className="label" htmlFor={name}>
              {caption}
            </label>
            <div className="control">
              <textarea
                className="textarea"
                name={name}
                onChange={this.handleChange}
                id={name}
                required={required}
              />
            </div>
          </div>
        );
      case 'select':
        return (
          <div className="field" key={name}>
            <label className="label" htmlFor={name}>
              {caption}
            </label>
            <div className="control">
              <div className="select is-fullwidth">
                <select name={name} id={name} onChange={this.handleChange} required={required}>
                  {choices.map(({ value, caption }) => (
                    <option value={value} key={value}>
                      {caption}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  }
}

function buildOrderConfig(title = '') {
  return {
    fields: [
      {
        caption: 'Цвет',
        type: 'select',
        name: 'color',
        hidden: title === 'Букет месяца',
        choices: [
          {
            caption: 'Любой',
            value: 'любой',
          },
          {
            caption: 'Яркий',
            value: 'яркий',
          },
          {
            caption: 'Нежный',
            value: 'нежный',
          },
          {
            caption: 'Конкретный...',
            value: 'конкретный',
          },
        ],
      },

      {
        caption: 'Опишите конкретный цвет',
        type: 'text',
        name: 'particular_color',
        condition: {
          color: 'конкретный',
        },
        nested: true,
      },

      {
        caption: 'Оформление (бесплатно)',
        type: 'select',
        name: 'decor',
        hidden: title === 'Букет месяца',
        choices: ~title.indexOf('укет') // для букетов одно оформление, для композиции другое
          ? [
              {
                caption: 'Букет без упаковки',
                value: 'букет-без-упаковки',
              },
              {
                caption: 'Букет с упаковкой',
                value: 'букет-с-упаковкой',
              },
            ]
          : [
              {
                caption: 'Композиция в корзинке',
                value: 'композиция-в-корзинке',
              },
              {
                caption: 'Композиция в деревянном ящике',
                value: 'композиция-в-деревянном-ящике',
              },
              {
                caption: 'Композиция в шляпной коробке',
                value: 'композиция-в-шляпной-коробке',
              },
              {
                caption: 'Композиция в кашпо',
                value: 'композиция-в-кашпо',
              },
            ],
      },

      {
        caption: 'Номер телефона',
        type: 'text',
        name: 'phone',
        required: true,
      },

      {
        caption: 'Способ связи',
        type: 'select',
        name: 'way',
        choices: [
          {
            caption: 'WhatsApp',
            value: 'whatsapp',
          },
          {
            caption: 'Telegram',
            value: 'telegram',
          },
          {
            caption: 'Звонок',
            value: 'звонок',
          },
          {
            caption: 'Электронная почта...',
            value: 'электронная-почта',
          },
        ],
      },

      {
        caption: 'Электронная почта',
        type: 'text',
        name: 'email',
        condition: {
          way: 'электронная-почта',
        },
        nested: true,
      },

      {
        caption: 'Передача букета',
        type: 'select',
        name: 'delivery',
        choices: [
          {
            caption: 'Самовывоз',
            value: 'самовывоз',
          },
          {
            caption: 'Доставка',
            value: 'доставка',
          },
        ],
      },

      {
        caption: 'Куда доставить?',
        type: 'text',
        name: 'delivery_address',
        condition: {
          delivery: 'доставка',
        },
      },

      {
        caption: 'Когда нужны цветы?',
        type: 'text',
        name: 'due_date',
      },

      {
        caption: 'Как тебя зовут?',
        type: 'text',
        name: 'name',
      },

      {
        caption: 'Комментарий',
        type: 'textarea',
        name: 'message',
      },
    ],
    submit: {
      caption: 'Отправить заявку',
    },
    success: {
      text: 'Заказ отправлен. Я свяжусь с тобой в ближайшее время!',
    },
  };
}

const feedbackConfig = {
  fields: [
    {
      caption: 'Как тебя зовут?',
      type: 'text',
      name: 'name',
    },

    {
      caption: 'Номер телефона',
      type: 'text',
      name: 'phone',
      required: true,
    },

    {
      caption: 'Способ связи',
      type: 'select',
      name: 'way',
      choices: [
        {
          caption: 'WhatsApp',
          value: 'whatsapp',
        },
        {
          caption: 'Telegram',
          value: 'telegram',
        },
        {
          caption: 'Звонок',
          value: 'звонок',
        },
        {
          caption: 'Электронная почта...',
          value: 'электронная-почта',
        },
      ],
    },

    {
      caption: 'Электронная почта',
      type: 'text',
      name: 'email',
      condition: {
        way: 'электронная-почта',
      },
      nested: true,
    },

    {
      caption: 'Сообщение',
      type: 'textarea',
      name: 'message',
    },
  ],

  submit: {
    caption: 'Отправить сообщение',
  },
  success: {
    text: 'Сообщение отправлено. Я свяжусь с тобой в ближайшее время!',
  },
};
